const labels = {
  acceptUser: 'Accept user',
  accepted: 'Accepted',
  add: 'Add',
  address: 'Address',
  all: 'All',
  allUsers: 'All users',
  amount: 'Amount',
  annotations: 'Annotations',
  approved: 'Approved',
  assignedAt: 'Assigned at',
  assignedBy: 'Assigned by',
  attachedFiles: 'Attached files',
  back: 'Back',
  balance: 'Balance',
  buy: 'Buy',
  cancel: 'Cancel',
  capturedOn: 'Captured on',
  citizenship: 'Citizenship',
  city: 'City',
  close: 'Close',
  closed: 'Closed',
  code: 'Code',
  completed: 'Completed',
  confirm: 'Confirm',
  confirmRequest: 'Confirm request',
  congratulations: 'Congratulations',
  counterpart: 'Counterpart',
  country: 'Country',
  customerData: 'Customer data',
  dashboard: 'Dashboard',
  date: 'Date',
  dateOfBirth: 'Date of birth',
  detail: 'Detail',
  document: 'Document',
  done: 'Done',
  download: 'Download',
  dropDocument: 'Drop document',
  edit: 'Edit',
  effect: 'Effect',
  email: 'Email',
  externalReference: 'External reference',
  evaluated: 'Evaluated',
  file: 'File',
  files: 'Files',
  from: 'From',
  gender: 'Gender',
  handling: 'Handling',
  hash: 'Hash',
  high: 'High',
  info: 'Info',
  inviteUser: 'Invite user',
  involvment: 'Involvment',
  issue: 'Issue',
  kybVerify: 'KYB Verify',
  kycVerify: 'KYC Verify',
  level: 'Level',
  low: 'Low',
  manage: 'Manage',
  medium: 'Medium',
  message: 'Message',
  metadata: 'Metadata',
  more: 'More',
  name: 'Name',
  new: 'New',
  next: 'Next',
  no: 'No',
  note: 'Note',
  paymentMethod: 'Payment method',
  pending: 'Pending',
  placeOfBirth: 'Place of birth',
  purchase: 'Purchase',
  quantity: 'Quantity',
  recipient: 'Recipient',
  rejectUser: 'Reject user',
  rejected: 'Rejected',
  reviewDecision: 'Review decision',
  save: 'Save',
  search: 'Search',
  searchByFirstOrLastName: 'Search by first or last name',
  searchByTypeOrFullName: 'Search by type (INDIVIDUAL/COMPANY) or full name',
  searchByLastNameWalletStateKeyOrSarId:
    'Search by last name, wallet, state key (done, todo, ...), or SAR ID',
  searchByNameEmailOrRole: 'Search by first name, last name, or email',
  searchByWallet: 'Search by wallet',
  searchByWalletOrName: 'Search by wallet or name',
  select: 'Select',
  selectWallet: 'Select wallet',
  sell: 'Sell',
  sender: 'Sender',
  severe: 'Severe',
  signOut: 'Sign out',
  specify: 'Specify',
  status: 'Status',
  summary: 'Summary',
  supportingDocumentation: 'Supporting documentation',
  surname: 'Surname',
  taxId: 'Tax ID',
  to: 'To',
  today: 'Today',
  todo: 'Todo',
  token: 'Token',
  transaction: 'Transaction',
  tryAgain: 'Try again',
  type: 'Type',
  unassigned: 'Unassigned',
  update: 'Update',
  user: 'User',
  userRegistry: 'User registry',
  verifiedBy: 'Verified by',
  verified: 'Verified',
  verify: 'Verify',
  verifyDate: 'Verify date',
  video: 'Video',
  view: 'View',
  wallet: 'Wallet',
  wallets: 'Wallets',
  yes: 'Yes',
};

export default labels;
